import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';

import BasicProfileForm from './BasicProfileForm';

/**
 * IdentityCard: the cross-ecosystem identity surface on the Profile page.
 *
 * This card holds the user's PLATFORM-LEVEL identity: name, profile picture,
 * bio, email. Edits here apply across every ecosystem the user belongs to
 * because these fields live on the platform User document, not on any
 * per-ecosystem membership row.
 *
 * It is rendered at the top of both the apex `/profile` view and every
 * tenant `/{slug}/profile` view, so the user always sees a consistent
 * "this is who I am everywhere" anchor before any per-ecosystem state.
 */
export default function IdentityCard({ profile, onUpdate }) {
    return (
        <Card className="shadow-sm" id="identity">
            <Card.Header className="bg-white border-bottom">
                <strong>My RILE Connect Profile</strong>
                <div className="text-muted small mt-1">
                    Your name, photo, and bio appear across every ecosystem you
                    belong to.
                </div>
            </Card.Header>
            <Card.Body className="p-4">
                <BasicProfileForm profile={profile} onUpdate={onUpdate} />
            </Card.Body>
        </Card>
    );
}

IdentityCard.propTypes = {
    profile: PropTypes.shape({
        name: PropTypes.shape({
            first: PropTypes.string,
            last: PropTypes.string,
        }),
        bio: PropTypes.string,
        email: PropTypes.string,
        profilePicture: PropTypes.string,
    }),
    onUpdate: PropTypes.func,
};
